import {getIntFromId} from "../../utils/getIntFromId";

export const testColors = {
  lightMint: "#84DFC0",
  lightRed: "#EC9C65",
  lightBlue: "#B6E0EB",
  anotherLightBlue: "#CDE8EF",
  darkBlue: "#15466A",
};

/**
 * uses hardcoded hexes because @c10h/colors is not supported in Edge runtime
 * which is required for og image generation
 */
const colors = {
  lightGreen: "#6bd9a1",
  darkerGreen: "#0b5c53",
  lightPurple: "#d6c0d8",
  darkerPurple: "#56336e",
  lightYellow: "#f3d95a",
  gray800: "#19191b",
  darkerBlue: "#1c4f75",
};

const colorRotation = [
  {
    patternSrc: "green",
    backgroundColor: colors.lightGreen,
    color: colors.darkerGreen,
  },
  {
    patternSrc: "purple",
    backgroundColor: colors.lightPurple,
    color: colors.darkerPurple,
  },
  {
    patternSrc: "yellow",
    backgroundColor: colors.lightYellow,
    color: colors.gray800,
  },
  {
    patternSrc: "mint",
    backgroundColor: testColors.lightMint,
    color: colors.darkerGreen,
  },
  {
    patternSrc: "red",
    backgroundColor: testColors.lightRed,
    color: colors.gray800,
  },
  {
    patternSrc: "blue",
    backgroundColor: testColors.lightBlue,
    color: colors.darkerBlue,
  },
];

export const getCareDiscoveryColorScheme = (
  uuid: string,
  apptReasonName = "",
): (typeof colorRotation)[number] => {
  const rotationIndex = /urin/gi.test(apptReasonName)
    ? 5 // If name as "urin" then just give it blue just in case it gets yellow
    : getIntFromId(uuid) % colorRotation.length;

  return colorRotation[rotationIndex];
};
